<template>
  <li class="u-border-graydb item-notice-area">
    <a :href="productURL" target="_blank">
      <div class="c-card-list__inbox">      
        <div class="c-card-photo"><img v-bind:src="product.image" width="130" height="100" /></div>
        <div class="c-card-list__text">
          <span v-if="product.buy_status == 'buyable'" class="item-status u-buy-ok">○ 在庫あり</span>
          <span v-else-if="product.buy_status == 'before_release'" class="item-status u-wait">× 販売開始前</span>        
          <span v-else-if="product.buy_status == 'priority'" class="item-status u-priority">△ 優先販売中</span>
          <span v-else-if="product.buy_status == 'soldout'" class="item-status u-priority">× 販売終了</span>
          <span v-else-if="product.buy_status == 'premium_only'" class="item-status u-buy-ok">○ 在庫あり</span>
          <span v-else class="item-status u-wait">× 入荷待ち</span>

          <p class="c-card__title ellipsis">{{product.shop_name}} {{product.name}}</p>
          <p class="c-card__tx1 ellipsis-row2">{{product.title}}</p>
          <p class="c-card__tx2 ellipsis-row2">{{product.lead_sentence}}</p>
          
        </div>
        <div class="notice-area u-tx-right c-flex-sp">
          <div class="notice-select c-flex-sp">
            <p class="notice-btn">
              <button v-if="isSignedIn == true && notifiedIds.includes(product.id) === true" @click.prevent=""><img src="/packs/media/images/common/btn-notice-on-4817d1e64860b6506e7609bd306199e3.svg" width="30" height="30"></button>
              <button v-else-if="isSignedIn == true && notifiedIds.includes(product.id) === false" @click.prevent="registerNotify(product.id)"><img src="/packs/media/images/common/btn-notice-off-212d8adf082f95e750f54825a149db76.svg" width="30" height="30"></button>
              <button v-else @click.prevent="showLoginNeededModal('入荷通知登録')"><img src="/packs/media/images/common/btn-notice-off-212d8adf082f95e750f54825a149db76.svg" width="30" height="30"></button>
            </p>
            <p class="favorite-btn">
              <button v-if="isSignedIn == true && favoritedIds.includes(product.id) === true" @click.prevent=""><img src="/packs/media/images/common/btn-favorite-on-815c956c84290f71db08ea56081e2f87.svg" width="30" height="30"></button>
              <button v-else-if="isSignedIn == true && favoritedIds.includes(product.id) === false" @click.prevent="registerFavorite(product.id)"><img src="/packs/media/images/common/btn-favorite-off-c73c5710b122f2672d89821b9efa2786.svg" width="30" height="30"></button>
              <button v-else @click.prevent="showLoginNeededModal('お気に入り登録')"><img src="/packs/media/images/common/btn-favorite-off-c73c5710b122f2672d89821b9efa2786.svg" width="30" height="30"></button>
            </p>
          </div>
          <p class="c-price-tx u-tx-right c-price-include-tx-area">
            <span class="c-price__num">{{product.price | numeral('0,0')}}</span>円
            <br>
            <span class="c-price-included-tx">(税込{{product.tax_included_price | numeral('0,0')}}円)</span>
          </p>
        </div>        
      </div>
    </a>
</li>
</template>
<script>
import axios from 'axios';
export default {
  props: {
    product: {},
    isSignedIn: false,
    favoritedIds: [],
    notifiedIds: [],
  },
  computed: {
    productURL: function(){
      return "/products/" + this.product.id
    }
  },
  methods: {
    showLoginNeededModal: function(action){
      alert(`${action}には、会員登録およびログインが必要です！`);
      e.preventDefault();      
      return false;
    },

    registerNotify: function(productId){
      axios
       .post(`/products/${productId}/notify.json`)
       .then(response =>{
        let newNotifiedIds = this.notifiedIds;
        newNotifiedIds.push(productId);
        this.notifiedIds = newNotifiedIds;
        alert(`入荷通知登録が完了しました！`);
      });      
    },

    registerFavorite: function(productId){
      axios
       .post('/favorites.json', {product_id: productId})
       .then(response =>{
        let newFavoritedIds = this.favoritedIds;
        newFavoritedIds.push(productId);
        this.favoritedIds = newFavoritedIds;
        alert(`お気に入り登録が完了しました！`);
      });
    },
  }
}
</script>